module.exports = __webpack_public_path__ + "static/media/tracking.edc1be90.svg";